import {
    FIELD_OF_STUDY_LIST_REQUEST,
    FIELD_OF_STUDY_LIST_SUCCESS,
    FIELD_OF_STUDY_LIST_FAIL,
} from '../constants/fieldofStudyConstants'

export const fieldsListReducer = (state = {}, action) => {
    switch (action.type) {
        case FIELD_OF_STUDY_LIST_REQUEST:
            return { loading: true }
        case FIELD_OF_STUDY_LIST_SUCCESS:
            return { loading: false, fields: action.payload }
        case FIELD_OF_STUDY_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

